import { InputForm } from "../types";

// The Last Ping column's field doubles as the server-side sort key and as
// the match key for the hideLastPing column filter in users-list/index.tsx,
// so both must reference this constant rather than repeat the string.
export const LAST_PING_COL_FIELD = 'mobileLocation.updatedAt';

export const USER_APPOINTMENT_COLUMNS = [
    {
        field: 'startDate',
        headerName: 'Scheduled Time',
        width: 250,
    },
    {
        field: 'title',
        headerName: 'Title',
        width: 150,
    },
    {
        field: 'notes',
        headerName: 'Notes',
        width: 150,
    },
    {
        field: 'userName',
        headerName: 'User Name',
        width: 150,
    },
    {
        field: 'userPhone',
        headerName: 'User Phone',
        width: 150,
    },
]

// NOTE: `field` here is a stable identifier for the column slot — it does
// NOT have to match a property path on UserTypes.Model. The table cells
// in users-list/index.tsx render manually (e.g. `user?.group?.name` for
// the Group column, `getTeamName(user)` for Team), so the field names
// are display-side labels only. If/when this list moves to a DataGrid
// with auto-render, the `field` strings will need to be reconciled
// with the actual response shape (Group is nested at `user.group.name`,
// not a flat `user.groupName`).
export const USER_COLUMNS = [
    {
        field: 'firstName',
        headerName: 'Name',
        width: 220,
    },
    {
        field: 'groupName',
        headerName: 'Group',
        width: 150,
        // Group is derived server-side from user.team.groupId; the user
        // document has no top-level groupName field, so a header click
        // sort would no-op. Opt out of the sort affordance entirely.
        sortable: false,
    },
    {
        field: 'teamId',
        headerName: 'Team',
        width: 150,
    },
    {
        field: 'phoneNumber',
        headerName: 'Phone Number',
        width: 150,
    },
    {
        field: 'appStatus',
        headerName: 'Mobile App',
        width: 200,
    },
    {
        // Sort by the app heartbeat, not the doc-level updatedAt (bumped
        // by any admin/bulk write). The API translates this key into a
        // computed max(mobileLocation.updatedAt, lastHeartbeatTimestamp)
        // sort. The cell additionally displays device pings; sorting by
        // those too would require a pre-pagination devices lookup
        // server-side, so device-only users may sort slightly off from
        // the displayed value.
        field: LAST_PING_COL_FIELD,
        headerName: 'Last Ping',
        width: 150,
    },
    {
        field: 'appVersion',
        headerName: 'App Version',
        width: 100,
    },
];

export const USER_FILTER_INPUTS: InputForm[] = [
    {
        label: 'Name',
        id: 'name',
        type: 'text',
        required: false,
        placeholder: 'Filter by name',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
    {
        label: 'Phone Number',
        id: 'phoneNumber',
        type: 'text',
        required: false,
        placeholder: 'Filter by phone number',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
    {
        label: 'Employee ID',
        id: 'employeeId',
        type: 'text',
        required: false,
        placeholder: 'Filter by employee id',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        }
    }
];